/* eslint-disable no-param-reassign,import/no-named-as-default */
import { take, fork, cancel, select } from 'redux-saga/effects';
import isPlainObject from 'lodash/isPlainObject';
import isString from 'lodash/isString';
import isNil from 'lodash/isNil';
import moment from 'moment';

import {
  hasProviderProfileSelector,
  selectLoggedProviderOrganizationCode,
} from '../../redux/context/selectors';
import manageResponse from './manage-response';
import api from '../api';
import { REQUEST_HEADERS_OPTIONS } from '../../constants';
import {
  ROOM_INVITATION_TOKEN,
  PAPERWORK_TOKEN,
} from '../../constants/storageKeys';
import { checkIsPaperworkRoute } from '../paperwork';

function getByKey(data, key) {
  if (data instanceof FormData) {
    return data.get(key);
  }
  return data[key];
}

const getSlug = (slug, payload, querySeparator) => {
  if (!Array.isArray(slug)) {
    return '';
  }

  return slug.reduce((acc, s) => {
    if (isPlainObject(s)) {
      switch (s.type) {
        case 'payload':
          acc += `/${s.selector.map(key => getByKey(payload, key)).join('/')}`;
          break;
        case 'payload.query':
          if (payload && !isNil(payload[s.selector])) {
            const value = payload[s.selector];

            if (Array.isArray(value)) {
              value.forEach(item => {
                acc += `${querySeparator}${s.queryParameter}[]=${item}`;
                querySeparator = '&';
              });
            } else {
              acc += `${querySeparator}${s.queryParameter}=${
                payload[s.selector]
              }`;
              querySeparator = '&';
            }
          }
          if (s.value) {
            acc += `${querySeparator}${s.queryParameter}=${s.value}`;
            querySeparator = '&';
          }

          break;
        case 'localStorage':
          acc += `/${s.selector
            .map(key => window.storage.getItem(key))
            .join('/')}`;
          break;
        default:
          return acc;
      }
    } else if (isString(s)) {
      acc += `/${s}`;
    }

    return acc;
  }, '');
};

export default function(
  constants,
  actions,
  { endpoint, options, slug, type },
  isLatest,
) {
  return function* watcher() {
    let lastTask;
    const headerOptions = {};

    while (true) {
      const isProvider = yield select(hasProviderProfileSelector);
      const organizationCode = yield select(
        selectLoggedProviderOrganizationCode,
      );

      const { payload } = yield take(constants.SEND);

      const querySeparator = '?';
      const fullEndpoint = `${endpoint}${getSlug(
        slug,
        payload,
        querySeparator,
      )}`;

      const selectedTeamId = window.storage.getItem('selectedTeamId');
      const authenticationToken = window.storage.getItem('authenticationToken');
      const roomInvitationToken = window.storage.getItem(ROOM_INVITATION_TOKEN);
      const paperworkToken = window.storage.getItem(PAPERWORK_TOKEN);
      const offset = moment().utcOffset() / 60;
      const timeOffset = (offset < 0 ? '' : '+') + offset;

      if (selectedTeamId)
        headerOptions[REQUEST_HEADERS_OPTIONS.SELECTED_TEAM] = selectedTeamId;
      if (isProvider && organizationCode)
        headerOptions[
          REQUEST_HEADERS_OPTIONS.ORGANIZATION_CODE
        ] = organizationCode;

      const { isPaperworkRoute } = checkIsPaperworkRoute();

      const resolvedPaperworkToken =
        isPaperworkRoute && (paperworkToken || authenticationToken);

      const commonHeaders = {
        TimeZone: timeOffset,
        TimeZoneName: Intl.DateTimeFormat().resolvedOptions().timeZone,
        platform: 'P_WEB',
        ...headerOptions,
      };

      let headers;

      if (roomInvitationToken) {
        headers = {
          Authorization: `Token token=${roomInvitationToken}, token_type=room_invitation`,
          ...commonHeaders,
        };
      } else if (resolvedPaperworkToken) {
        headers = {
          headers: {
            Authorization: `Bearer token=${resolvedPaperworkToken}, token_type=paperwork`,
            ...commonHeaders,
          },
        };
      } else if (authenticationToken) {
        headers = {
          headers: {
            Authorization: `Token token=${authenticationToken}`,
            ...commonHeaders,
          },
        };
      } else {
        headers = { headers: { platform: 'P_WEB' } };
      }

      const opts = {
        ...options,
        ...headers,
      };

      if (lastTask && isLatest) {
        yield cancel(lastTask);
      }

      lastTask = yield fork(
        manageResponse,
        actions,
        api(fullEndpoint, opts, type),
        payload,
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/utils/redux/req-watcher.js